import { api } from '../../../shared/services/api/client';
import { createLogger } from '../../../shared/config/logger';
const logger = createLogger('tutorial_api');

export async function fetchTutorialStatus() {
    logger.info('Fetching tutorial status (frontend API call)');
    try {
        const response = await api.get('/settings/tutorial');
        logger.info('Fetched tutorial status successfully', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Error fetching tutorial status', { error });
        throw error;
    }
}

export async function updateTutorialStatus(tutorial_completed) {
    logger.info('Updating tutorial status (frontend API call)', { tutorial_completed });
    try {
        const response = await api.patch('/settings/tutorial', { tutorial_completed });
        logger.info('Updated tutorial status successfully', { data: response.data });
        return response;
    } catch (error) {
        logger.error('Error updating tutorial status', { error });
        throw error;
    }
}

